// Password validation rules
export const PASSWORD_RULES = {
  minLength: 8,
  requireUppercase: true,
  requireLowercase: true,
  requireNumber: true,
  requireSpecialChar: true,
};

// Email validation regex - more permissive version
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// Phone number validation regex - US only, 10 digits
export const PHONE_REGEX = /^\d{10}$/;

export const validatePassword = (password) => {
  if (!password) return null;

  const errors = [];
  const checks = {
    length: password.length >= PASSWORD_RULES.minLength,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /\d/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  };

  if (password.length < PASSWORD_RULES.minLength) {
    errors.push(
      `Password must be at least ${PASSWORD_RULES.minLength} characters long`
    );
  }
  if (PASSWORD_RULES.requireUppercase && !checks.uppercase) {
    errors.push("Password must contain at least one uppercase letter");
  }
  if (PASSWORD_RULES.requireLowercase && !checks.lowercase) {
    errors.push("Password must contain at least one lowercase letter");
  }
  if (PASSWORD_RULES.requireNumber && !checks.number) {
    errors.push("Password must contain at least one number");
  }
  if (PASSWORD_RULES.requireSpecialChar && !checks.special) {
    errors.push("Password must contain at least one special character");
  }

  return {
    isValid: errors.length === 0,
    errors: errors.length > 0 ? errors : null,
    checks,
  };
};

export const validateEmail = (email) => {
  if (!email) return { isValid: false, error: "Email is required" };
  if (!EMAIL_REGEX.test(email)) {
    return { isValid: false, error: "Please enter a valid email address" };
  }
  if (email.length > 254) {
    return { isValid: false, error: "Email address is too long" };
  }
  return { isValid: true };
};

export const validatePhone = (phone) => {
  if (!phone) return { isValid: true }; // Phone is optional
  if (!PHONE_REGEX.test(phone)) {
    return {
      isValid: false,
      error: "Please enter a valid 10-digit US phone number",
    };
  }
  return { isValid: true };
};

export const validateDisplayName = (name) => {
  if (!name.trim()) {
    return { isValid: false, error: "Display name is required" };
  }
  if (name.length < 2) {
    return {
      isValid: false,
      error: "Display name must be at least 2 characters long",
    };
  }
  if (name.length > 100) {
    return {
      isValid: false,
      error: "Display name must be less than 100 characters",
    };
  }
  return { isValid: true };
};
